<div class="header_search">
  <div class="title-page">
    <h3>Legislação e Manuais</h3>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Principais links</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of legislacaoList; let i = index">
          <tr [ngClass]="{'border-b-radius': i == legislacaoList?.length - 1}">
            <td class="title">
              <a [href]="item?.url" target="_blank">{{item?.name}}</a>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="!legislacaoList?.length" class="border-b-radius">
          <td colspan="1" class="text-center">Nenhum Link Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="idProjeto && canDeleteProj" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-white m-r-xs" *ngIf="idProjeto" type="button" (click)="imprimir()">Imprimir</button>
      <button class="btn btn-white m-r-xs" *ngIf="idProjeto && canCloneProj" type="button" (click)="openCloneModal()">Clonar</button>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>